// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-cover[data-v-4896fc76]{height:100%;width:30%;object-fit:cover}", ""]);
// Exports
module.exports = exports;
